/**
 * Article Table of Contents - minimal TOC on desktop
 * Builds TOC from h2/h3 in article content, desktop only
 */
(function () {
  if (typeof document === 'undefined' || !document.querySelector) return;

  function initArticleToc() {
    const toc = document.getElementById('article-toc');
    const content = document.querySelector('.article-template__content');
    if (!toc || !content) return;

    const headings = content.querySelectorAll('h2, h3');
    if (headings.length === 0) return;

    const fragment = document.createDocumentFragment();
    const list = document.createElement('ul');
    list.className = 'article-toc__list';

    headings.forEach(function (heading, index) {
      let id = heading.id;
      if (!id) {
        id = 'heading-' + index;
        heading.id = id;
      }

      const item = document.createElement('li');
      item.className = 'article-toc__item article-toc__item--' + heading.tagName.toLowerCase();

      const link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent.trim();
      link.className = 'article-toc__link';

      link.addEventListener('click', function (event) {
        const target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && window.history.pushState) {
          window.history.pushState(null, '', '#' + id);
        }
      });

      item.appendChild(link);
      list.appendChild(item);
    });

    const label = document.createElement('span');
    label.className = 'article-toc__label';
    label.textContent = 'On this page';

    fragment.appendChild(label);
    fragment.appendChild(list);
    toc.appendChild(fragment);
    toc.hidden = false;
  }

  function wrapReferences() {
    const content = document.querySelector('.article-template__content');
    if (!content || content.querySelector('.article-references')) return;

    const headings = content.querySelectorAll('h2');
    let refHeading = null;
    headings.forEach(function (h) {
      if (h.textContent.trim().toLowerCase() === 'references') refHeading = h;
    });
    if (!refHeading) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'article-references';
    refHeading.parentNode.insertBefore(wrapper, refHeading);

    let node = refHeading;
    while (node) {
      const next = node.nextSibling;
      wrapper.appendChild(node);
      node = next;
    }
  }

  function init() {
    initArticleToc();
    wrapReferences();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
